export const activeClubMembershipsWithoutThisAddress = (
  addressId,
  clubMemberships
) => {
  if (!clubMemberships) {
    return [];
  }
  const filteredMemberships = clubMemberships.filter(
    (clubMembership) => clubMembership.shipToCustomerAddressId !== addressId
  );
  return filteredMemberships;
};

export const isClubMembershipsWithoutThisAddress = (
  addressId,
  clubMemberships
) => {
  const memberships = activeClubMembershipsWithoutThisAddress(
    addressId,
    clubMemberships
  );
  if (memberships.length > 0) {
    return true;
  }
  return false;
};
